<template>

<div class='row'>
    <div class="col-12">
        <a :href="url()" class='bc-item'>Начало</a>  
        
        <a v-for='(l,i) in $store.state.bcLinks' 
                    :key='l.name' :href='i+1 == $store.state.bcLinks.length ? "" : url(l.url)' 
                    class='bc-item'>

            {{ l.name }} 

        </a>

    </div>
</div>

</template>

<script>
    export default {
        mounted() {

        },

    }
</script>
<style>

.bc-item {
    margin-right: 10px;
    padding: 5px;
    border: 1px solid;
    background-color:  white;
}

</style>